import { Pipe, PipeTransform } from '@angular/core';
import { GLOBAL_ORG_ID } from '@global';

import { FormElement } from '@state/form';

@Pipe({ name: 'fieldNotInGlobalOrg' })
export class FieldNotInGlobalOrgPipe implements PipeTransform {
  constructor() {}

  transform(formElement: FormElement): boolean {
    let { custom_variable_organization_id } = formElement.element_object;
    if (!custom_variable_organization_id) return false;

    return GLOBAL_ORG_ID !== custom_variable_organization_id;
  }
}
